import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DI from "../utility/DI";
import { CircularProgress } from "@mui/material";
import Footer from "../utility/Footer";
import { useNavigate } from "react-router-dom";
import { PasswordInput } from "../utility/PasswordInput";
function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}


const ForgetPassword = (props) => {
  const [countdown, setcoundown] = React.useState(0);
  const {
    di: {
      success,
      error,
      POST,
      urls,
      contextData: { setState },
    },
  } = props;
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (countdown > 0)
      setTimeout(() => {
        setcoundown((prev) => prev - 1);
      }, 1000);
  }, [countdown]);



  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get("email");
    if (email) {
      setLoading(true);
      POST(urls.post.reset_password, {
        email,
      })
        .then((res) => {
          if (res.success) {
            setLoading(false);
            setcoundown(30);
            success(res?.message);
          } else {
            setLoading(false);
            error(res?.message);
          }
        })
        .catch((er) => {
          setLoading(false);
          error("Refresh page & Try again.");
          console.log({ Error: er });
        });
    } else error("Please enter your email.");
  };

  
  return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minWidth: "300px",
          }}
        >
          <div style={{ width: "80px" }}>
            <img
              style={{ width: "100%" }}
              src={"/transparent_logo.png"}
              alt={"spent_app"}
              loading="lazy"
            />
          </div>
          <Typography component="h1" sx={{ mt: 4 }} variant="h5">
            Enter Account Email
          </Typography>
          <small>To change password</small>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 3, px: 2, minWidth: "25vw" }}
          >
            <TextField
              margin="normal"
              sx={{mb:2}}
              required
              placeholder={"jai@gmail.com"}
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
     <small style={{ color: "grey",paddingLeft:'5px',fontSize:'16px' }}>
              {countdown > 0 ? (
                <>
                  Check your email inbox.
                  <strong
                    style={{ color: "orange" }}
                  >{` Can Resend in ${countdown}s.`}</strong>
                </>
              ) : (
                "Note: Link valid till 15 minutes only."
              )}
            </small>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              loading={true}
              disabled={countdown > 0}
              sx={{ mt: 1, mb: 2,}}
            >
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                "SEND LINK"
              )}
            </Button>
       
          </Box>
        </Box>
        <div style={{ marginTop: "20px" }}>
          <Footer />
        </div>
      </Container>
  );
};
export default DI(ForgetPassword);
